// extracted by mini-css-extract-plugin
module.exports =  {"cont":"_93444fe79c--cont--OzgVc","controls":"_93444fe79c--controls--tD3y2","gallery-arrow":"_93444fe79c--gallery-arrow--A4K39"};